import React from 'react'
import PropTypes from 'prop-types'

import FAIcon from '../icons/faIcon'
import StringUtils from '../../inumet_js_lib/utils/stringUtils'
import StylesUtils from '../../res/styles/stylesUtils'
import { Button, CircularProgress, Typography } from '@mui/material'

const DEFAULT_BUTTON_TYPE = 'info'

function ImgButton(props) {
    let buttonType = StringUtils.notNullNotEmptyNoStrNull(props.buttonType)
        ? props.buttonType
        : DEFAULT_BUTTON_TYPE
    let outlined = props.outlined ? 'outline-' : ''
    let spinnerLoading = null
    if (props.loading) {
        spinnerLoading = <CircularProgress key={'progress'} />
    }
    let classNameDiv = StylesUtils.getMarginClasses(
        props.mt,
        props.mr,
        props.mb,
        props.ml
    )
    let itemsButton = []
    if (!props.iconAtEnd) {
        if (!props.loading) {
            itemsButton.push(
                <FAIcon
                    key={'icon'}
                    fas
                    iconId={props.iconId}
                    textOnHover={props.textOnHover}
                />
            )
            itemsButton.push(
                <span key={'text'} className="ml-2">
                    <Typography sx={{ mt: 2 }}>
                        {props.text ? props.text : ''}
                    </Typography>
                </span>
            )
        } else {
            itemsButton.push(spinnerLoading)
            itemsButton.push(
                <span key={'loadingText'} className="ml-2">
                    <Typography sx={{ mt: 2 }}>
                        {props.loadingText ? props.loadingText : ''}
                    </Typography>
                </span>
            )
        }
    } else {
        if (!props.loading) {
            itemsButton.push(
                <span key={'text'} className="mr-2">
                    <Typography sx={{ mt: 2 }}>
                        {props.text ? props.text : ''}
                    </Typography>
                </span>
            )
            itemsButton.push(
                <FAIcon
                    key={'icon'}
                    fas
                    iconId={props.iconId}
                    textOnHover={props.textOnHover}
                />
            )
        } else {
            itemsButton.push(
                <span className="mr-2" key={'text'}>
                    {props.loadingText ? props.loadingText : ''}
                </span>
            )
            itemsButton.push(spinnerLoading)
        }
    }
    return (
        <Button
            className={classNameDiv}
            variant={outlined + buttonType}
            onClick={props.onClick}
            disabled={props.isDisabled}
        >
            {itemsButton}
        </Button>
    )
}

ImgButton.propTypes = {
    fas: PropTypes.bool,
    iconId: PropTypes.string,
    buttonType: PropTypes.string,
    textOnHover: PropTypes.string,
    onClick: PropTypes.func,
    text: PropTypes.string,
    outlined: PropTypes.bool,
    isDisabled: PropTypes.bool,
    loading: PropTypes.bool,
    loadingText: PropTypes.string,
    mr: PropTypes.number,
    ml: PropTypes.number,
    mt: PropTypes.number,
    mb: PropTypes.number,
    iconAtEnd: PropTypes.bool,
    /*size: PropTypes.number,
    verticalCenter: PropTypes.bool,

    iconStyle: PropTypes.object,*/
}

export { ImgButton as default }
